module.exports = __webpack_public_path__ + "static/img/model-swiper2.004cd9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/model-swiper2.jpg
// module id = 3UKQ
// module chunks = 0